import { Fragment } from 'react';

import { type IEscrowInvitation } from 'src/graphql/schema';
import { Button } from '@/components/ui/button';
import { CardContent, CardFooter } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

import { useBeneficiaryInvitationContext } from '../model';

const InvitationDetails = ({ escrowInvitation }: { escrowInvitation: IEscrowInvitation }) => {
  const { setMode } = useBeneficiaryInvitationContext();

  const startEditing = () => setMode('form');
  const startChangingBeneficiary = () => setMode('pick');

  const rows = [
    { id: 'organization-name', label: 'Organization name', value: escrowInvitation.companyName },
    { id: 'contact-name', label: 'Primary contact name', value: escrowInvitation.userName },
    { id: 'contact-email', label: 'Primary contact email', value: escrowInvitation.userEmail },
  ];

  return (
    <Fragment>
      <CardContent>
        <Table className="border-y border-border">
          <TableBody>
            {rows.map(({ id, label, value }) => (
              <TableRow key={id} className="hover:bg-white">
                <TableCell className="pl-0 py-3 w-50 font-semibold text-slate-700">{label}</TableCell>
                <TableCell className="py-3 px-0 w-4">:</TableCell>
                <TableCell className="py-3 text-foreground">
                  <div className="min-w-47.5">{value}</div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
      {escrowInvitation.policy.update && (
        <CardFooter className="bg-muted py-3 justify-end gap-2 rounded-b-xl">
          <Button variant="secondary" size="sm" onClick={startChangingBeneficiary}>
            Change beneficiary
          </Button>
          <Button variant="secondary" size="sm" onClick={startEditing}>
            Edit
          </Button>
        </CardFooter>
      )}
    </Fragment>
  );
};

export default InvitationDetails;
